const AppButtonList = (props: React.PropsWithChildren) => {
    return <div className="">
        {props.children}
    </div>
}

export default AppButtonList;